<template>
	<div id="contentPageBreak">
		<Page :current="pageData.pageNow+1" :total="pageData.pageTotal" :page-size="pageData.pageSize" @on-change="changePage"/>
	</div>
</template>

<script>
	export default {
		name: "contentPageBreak",
		props: ['pageData'],
		data() {
			return {
				pageSize:8
			};
		},
		methods: {
			changePage(n) {
				this.$emit('clickPage',n)
			},
		},
	};
</script>

<style>
	#contentPageBreak {
		text-align: center;
	}
</style>
